<template lang="pug">
  .mister-pdp(itemprop="product" itemscope itemtype="http://schema.org/Product")
    PdpBanner

    template(v-if='hasActiveSub')
      PdpExistingSubBanner(:quiz-completed='quizCompleted' quiz-url='/color-advisor-men' more-colors-url='/shop/mens')

    template(v-else)
      FixedWidthContainer
        .back-to-advisor.row.xs-f-small.lg-f-medium.max-at-tweak.text-center.xs-pt-100m.xs-pb-125m
          template(v-if="product.code == mensBestMatch")
            p.xs-f-small.lg-f-medium.max-at-tweak Based on your&nbsp;
              a.underline(href="/color-advisor-men") quiz
              |  we recommend:

          template(v-else-if="mensBestMatch")
            p.xs-f-small.lg-f-medium.max-at-tweak Back to your&nbsp;
              a.underline(href="/color-advisor-men") quiz results

    FixedWidthContainer
      DefaultPdpHero
        template(v-slot:middle="")
          PdpMissingMensAdvisor

    MisterValueProps

    LazyComponent
      template(#default="{ shown }")
        AccordionSections(v-if="shown")

    LazyComponent
      template(#default="{ shown }")
        LockupBanner(v-if="shown" :cms="cmsSettings.moneyBackGuarantee")

    FixedWidthContainer
      LazyComponent
        template(#default="{ shown }")
          ExpertiseIncluded.mens-theme(v-if="shown")

    LazyComponent
      template(#default="{ shown }")
        MisterUGC(v-if="shown && showMisterUGC")

    // UGC Images
    .row
      DashHudsonScript
        template(#title="")
          h3.bold.upper.xs-f-small.md-f-small.lg-f-large.max-at-tweak.text-center Real clients, really handsome results

    Reviews(:product-id="product.id" :product-url-key="product.url_key")

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import { defineAsyncComponent } from 'vue';
  import LazyComponent from '../../LazyComponent';
  import FixedWidthContainer from '../../FixedWidthContainer';
  import PdpBanner from '../PdpBanner';
  import DefaultPdpHero from '../DefaultPdp/DefaultPdpHero';
  import PdpMissingMensAdvisor from '../PdpMissingMensAdvisor';
  import PdpExistingSubBanner from "../PdpExistingSubBanner/PdpExistingSubBanner";
  import DashHudsonScript from "@components/PDP/DashHudsonScript.vue";

  export default {
    name: 'MisterPdp',
    inject: ['getObjProperty'],

    components: {
      DashHudsonScript,
      PdpExistingSubBanner,
      FixedWidthContainer,
      PdpBanner,
      DefaultPdpHero,
      PdpMissingMensAdvisor,
      LazyComponent,
      MisterValueProps: defineAsyncComponent(() => import('./MisterValueProps')),
      AccordionSections: defineAsyncComponent(() => import('../AccordionSections')),
      LockupBanner: defineAsyncComponent(() => import('../../banners/lockupBanner')),
      ExpertiseIncluded: defineAsyncComponent(() => import('../../ExpertiseIncluded')),
      MisterUGC: defineAsyncComponent(() => import('./MisterUGC')),
      Reviews: defineAsyncComponent(() => import('../Reviews')),
    },

    data() {
      return {
        colorMap: {
          graphite: 'MENSGRAPHITE',
          dark_blonde: 'MENSBLONDE',
          light_brown: 'MENSLTBROWN',
          medium_brown: 'MENSMEDBROWN',
          dark_brown_black: 'MENSBROWNBLACK',
        },
      };
    },

    computed: {
      ...mapState('pdp', [
        'product',
        'subscription'
      ]),

      ...mapGetters('pdp', [
        'hasActiveSub'
      ]),

      ...mapState('cms', ['cmsSettings']),
      ...mapState('colorAdvisor', ['answers']),

      mensBestMatch() {
        let desiredMensColor = this.getObjProperty(this.answers, 'desired_mens_color');

        return this.colorMap[desiredMensColor];
      },

      showMisterUGC() {
        return this.getObjProperty(this.cmsSettings, 'showMisterUGC');
      },

      quizCompleted() {
        return this.product.code == this.mensBestMatch;
      }
    },

    methods: {
      ...mapActions('colorAdvisor', ['getAdvisorData']),
      ...mapActions('pdp', ['openPurchasePanelModal']),
    },

    created() {
      this.getAdvisorData();

      if (this.$route.query.purchasePanel || this.$route.hash == '#purchase-modal') {
        let modalPayload = {
          theme: 'full-screen'
        };

        this.openPurchasePanelModal(modalPayload);
      }
    }

  };
</script>
